'use client';

import { ErrorComponent } from '~/components/ErrorComponent';

export default function AuthNotFoundPage() {
  return (
    <ErrorComponent
      errorCode="404"
      errorTitle="Page Not Found"
      errorMessage="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
      homeLink="/"
    />
  );
}
